import { api } from "@/helper/api";
import { resolveManagerCompanyFromMeResponse } from "@/components/lms/enrolmentAssignmentTargetSelection";

const managerCompanySubjectIdCache = new Map<string, Promise<string>>();

export const loadManagerCompanySubjectId = (companyName?: string) => {
  const cacheKey = companyName ?? "";
  const cachedRequest = managerCompanySubjectIdCache.get(cacheKey);

  if (cachedRequest) {
    return cachedRequest;
  }

  const request = new Promise<string>((resolve, reject) => {
    api.genericApiRequest({
      entity: "me",
      method: "get",
      successHandler: (response: any) => {
        const companyOption = resolveManagerCompanyFromMeResponse(
          response?.data,
          companyName,
        );
        resolve(String(companyOption?.value ?? ""));
      },
      failHandler: (requestError: any) => reject(requestError),
    });
  }).catch((requestError: any) => {
    managerCompanySubjectIdCache.delete(cacheKey);
    throw requestError;
  });

  managerCompanySubjectIdCache.set(cacheKey, request);
  return request;
};
